var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#7C84E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 22,
    height: 22,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12 h10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18 h10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavResources);
export default __webpack_public_path__ + "static/media/nav-resources.6b4bb5bcd046a7a602a28c1afca7a845.svg";
export { ForwardRef as ReactComponent };